import script from "./OrderProductOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductOffers.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductOffers.vue?vue&type=style&index=0&id=b2e3d946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2e3d946"]])

export default __exports__